import ContactMe from "../Components/ContactMe/ContactMe";
import PageWrapper from "../Components/PageWrapper/PageWrapper";

export default function Contact() {
  return (
    <PageWrapper>
      <ContactMe />
    </PageWrapper>
  );
}
